export const isLegacyVKeyEnabled = process.env.REACT_APP_LEGACY_VKEY_ENABLED === "true";
export const isVLinkEnabled = process.env.REACT_APP_VLINK_ENABLED === "true";
